import { QueryClient } from "@tanstack/react-query";

/**
 * Single TanStack Query client for the SPA. Defaults are tuned for an
 * admin-style app: refetch on window focus is off (operators leave tabs
 * open for hours), retries are conservative, stale data is acceptable for
 * 30 seconds before we consider it for re-fetch.
 */
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 30_000,
            gcTime: 5 * 60_000,
            refetchOnWindowFocus: false,
            retry: (failureCount, error) => {
                if (error instanceof Response && [400, 401, 403, 404].includes(error.status)) {
                    return false;
                }
                return failureCount < 2;
            },
        },
        mutations: {
            retry: false,
        },
    },
});
